import client from '../../client';
import {
  GET_REFUNDS,
  GET_REFUNDS_SUCCESS,
  GET_REFUNDS_FAIL,

  NEW_REFUND,
  NEW_REFUND_SUCCESS,
  NEW_REFUND_FAIL,

  GET_ZENDESK_DATA,
  GET_ZENDESK_DATA_SUCCESS,
  GET_ZENDESK_DATA_FAIL,

  NEW_COMMENT,
  NEW_COMMENT_SUCCESS,
  NEW_COMMENT_FAIL,

  UPDATE_REFUND_STATUS,
  UPDATE_REFUND_STATUS_SUCCESS,
  UPDATE_REFUND_STATUS_FAIL,

  UPDATE_REFUND,
  UPDATE_REFUND_SUCCESS,
  UPDATE_REFUND_FAIL,

  GET_REFUNDS_SUMMARY,
  GET_REFUNDS_SUMMARY_SUCCESS,
  GET_REFUNDS_SUMMARY_FAIL,

  RESET_ZENDESK_FIELDS,

  UPLOAD_FILES,
  UPLOAD_FILES_SUCCESS,
  UPLOAD_FILES_FAIL,

  GET_COMPLETED_REFUNDS,
  GET_COMPLETED_REFUNDS_SUCCESS,
  GET_COMPLETED_REFUNDS_FAIL,

  GET_REFUNDS_COUNT,
  GET_REFUNDS_COUNT_SUCCESS,
  GET_REFUNDS_COUNT_FAIL,

  GET_REFUND,
  GET_REFUND_SUCCESS,
  GET_REFUND_FAIL,

  GET_REFUND_TRANSACTIONS,
  GET_REFUND_TRANSACTIONS_SUCCESS,
  GET_REFUND_TRANSACTIONS_FAIL,

  MAKE_REFUND,
  MAKE_REFUND_SUCCESS,
  MAKE_REFUND_FAIL,

  MAKE_REFUNDS,
  MAKE_REFUNDS_SUCCESS,
  MAKE_REFUNDS_FAIL,

  SWITCH_REFUND_METHOD,
  SWITCH_REFUND_METHOD_SUCCESS,
  SWITCH_REFUND_METHOD_FAIL
} from '../constants/refunds';
import { notifyUser } from './notification';

export const getRefundData = (params) => dispatch => {
  dispatch({
    type: GET_REFUNDS
  });
  client
    .get('/refunds', { params: {
      ...params,
      ...(params.returned ? { status: 'RETURNED' } : {})
    } })
    .then(res => {
      dispatch({
        type: GET_REFUNDS_SUCCESS,
        data: res.data
      });
    })
    .catch(error => {
      dispatch({
        type: GET_REFUNDS_FAIL,
        error
      });
    });
}

export const getRefundRequestedData = (params) => dispatch => {
  dispatch({
    type: GET_REFUNDS
  });
  client
    .get('/refunds', { params: {
      ...params,
      status: 'REQUESTED'
    } })
    .then(res => {
      dispatch({
        type: GET_REFUNDS_SUCCESS,
        data: res.data
      });
    })
    .catch(error => {
      dispatch({
        type: GET_REFUNDS_FAIL,
        error
      });
    });
}

export const getRefundCompletedData = (params) => dispatch => {
  dispatch({
    type: GET_REFUNDS
  });
  client
    .get('/refunds', { params: {
      ...params,
      status: 'APPROVED'
    } })
    .then(res => {
      dispatch({
        type: GET_REFUNDS_SUCCESS,
        data: res.data
      });
    })
    .catch(error => {
      dispatch({
        type: GET_REFUNDS_FAIL,
        error
      });
    });
}

export const getZendeskData = (ticketId) => dispatch => {
  dispatch({
    type: GET_ZENDESK_DATA
  });
  client
    .get('/refunds/zendeskTicket', { params: { ticketId } })
    .then(({data}) => {
      dispatch({
        type: GET_ZENDESK_DATA_SUCCESS,
        data
      });
    })
    .catch(error => {
      dispatch({
        type: GET_ZENDESK_DATA_FAIL,
        error
      });
    });
}

export const createRefund = (params) => dispatch => {
  dispatch({
    type: NEW_REFUND
  });
  notifyUser({
    message: 'Refund is being requested',
    type: 'loading'
  })(dispatch)
  client
    .post('/refunds', params)
    .then(({data}) => {
      dispatch({
        type: NEW_REFUND_SUCCESS,
        data
      })
      notifyUser({
        message: 'Refund requested',
        type: 'success'
      })(dispatch)
    })
    .catch(error => {
      dispatch({
        type: NEW_REFUND_FAIL,
        error
      });
      notifyUser({
        title: 'Failed to request refund',
        message: 'zendesk ticket already exists',
        type: 'error'
      })(dispatch)

    })

}

export const addComment = (id, comment) => dispatch => {
  dispatch({
    type: NEW_COMMENT
  });
  client
    .put(`/refunds/${id}/comment`, { comment })
    .then(({data}) => {
      dispatch({
        type: NEW_COMMENT_SUCCESS,
        data
      });
    })
    .catch(error => {
      dispatch({
        type: NEW_COMMENT_FAIL,
        error
      })
    })
}

export const updateStatus = (id, status) => dispatch => {
  dispatch({
    type: UPDATE_REFUND_STATUS
  });
  notifyUser({
    title: 'Updating status',
    message: `Marking as ${status.toLowerCase()}`,
    type: 'loading'
  })(dispatch)
  client
    .put(`/refunds/${id}/status`, { status })
    .then(({data}) => {
      dispatch({
        type: UPDATE_REFUND_STATUS_SUCCESS,
        data
      });
      getRefundsSummary()(dispatch);
      notifyUser({
        message: `Refund marked as ${status.toLowerCase()}`,
        type: 'success'
      })(dispatch)
    })
    .catch(error => {
      dispatch({
        type: UPDATE_REFUND_STATUS_FAIL,
        error
      });
      notifyUser({
        title: `Failed to mark refund as ${status.toLowerCase()}`,
        message: JSON.stringify(error),
        type: 'error'
      })(dispatch)
    })
}

export const updateReturnedRefund = (id, params) => dispatch => {
  dispatch({
    type: UPDATE_REFUND
  });
  notifyUser({
    message: 'Updating refund',
    type: 'loading'
  })(dispatch)
  client
    .put(`/refunds/${id}`, params)
    .then(({data}) => {
      dispatch({
        type: UPDATE_REFUND_SUCCESS,
        data
      });
      notifyUser({
        message: 'Refund updated',
        type: 'success'
      })(dispatch);
    })
    .catch(error => {
      dispatch({
        type: UPDATE_REFUND_FAIL,
        error
      });
      notifyUser({
        title: 'Can\'t update refund',
        message: JSON.stringify(error),
        type: 'error'
      })(dispatch)
    })
}

export const getRefundsSummary = () => dispatch => {
  dispatch({
    type: GET_REFUNDS_SUMMARY
  });
  client
    .get('/refunds/summary')
    .then(({data}) => {
      dispatch({
        type: GET_REFUNDS_SUMMARY_SUCCESS,
        data
      });
    })
    .catch(error => {
      dispatch({
        type: GET_REFUNDS_SUMMARY_FAIL,
        error
      });
    });
}

export const getRefundsPaginated = (params) => dispatch => {
  dispatch({
    type: GET_REFUNDS
  });
  client
    .post('/refunds/paginate', params)
    .then(({data}) => {
      dispatch({
        type: GET_REFUNDS_SUCCESS,
        data: data.data,
        pages: data.pages,
        total: data.total
      });
    })
    .catch(error => {
      dispatch({
        type: GET_REFUNDS_FAIL,
        error
      });
    });
}

export const getCompletedRefunds = (params) => dispatch => {
  dispatch({
    type: GET_COMPLETED_REFUNDS
  });
  client
    .post('/refunds/completed', params)
    .then(({data}) => {
      dispatch({
        type: GET_COMPLETED_REFUNDS_SUCCESS,
        data: data.data,
        pages: data.pages,
        total: data.total,
        users: data.users
      });
    })
    .catch(error => {
      dispatch({
        type: GET_COMPLETED_REFUNDS_FAIL,
        error
      });
    });
}

export const resetZendeskFields = () => dispatch => dispatch({
  type: RESET_ZENDESK_FIELDS
})

export const uploadFiles = (id, data) => dispatch => {
  dispatch({
    type: UPLOAD_FILES
  });
  client
    .put(`/refunds/${id}/upload`, data)
    .then(({ data: uploads }) => {
      dispatch({
        type: UPLOAD_FILES_SUCCESS,
        data: uploads
      })
    })
    .catch(error => {

      dispatch({
        type: UPLOAD_FILES_FAIL,
        error
      })
    })
}

export const getRefundsCount = (msisdn) => dispatch => {
  dispatch({
    type: GET_REFUNDS_COUNT
  });
  client
    .get(`/refunds/${msisdn}/count`)
    .then(({ data }) => {
      dispatch({
        type: GET_REFUNDS_COUNT_SUCCESS,
        data
      })
    })
    .catch(error => {
      dispatch({
        type: GET_REFUNDS_COUNT_FAIL,
        error
      });
    })
}

export const fetchTicket = (id) => dispatch => {
  dispatch({
    type: GET_REFUND
  });
  client
    .get(`/refunds/${id}`)
    .then(({data}) => {
      dispatch({
        type: GET_REFUND_SUCCESS,
        data
      });
    })
    .catch(error => {
      dispatch({
        type: GET_REFUND_FAIL,
        error
      })
    })
}

export const getTransactions = (msisdn, oc, srvcId) => dispatch => {
  dispatch({
    type: GET_REFUND_TRANSACTIONS
  });
  client
    .get("/refunds/getTransactions", { params: { oc, msisdn }})
    .then(({ data }) => {
      dispatch({
        type: GET_REFUND_TRANSACTIONS_SUCCESS,
        data: data
      })
    })
    .catch(error => {
      dispatch({
        type: GET_REFUND_TRANSACTIONS_FAIL,
        error
      })
    })
}

export const makeRefund = data => dispatch => {
  dispatch({
    type: MAKE_REFUND,
    data
  });
  client
    .post('/refunds/process', data)
    .then(({ data: postData }) => {
      dispatch({
        type: MAKE_REFUND_SUCCESS,
        data,
        postData
      })
    })
    .catch(error => {
      dispatch({
        type: MAKE_REFUND_FAIL,
        data,
        error
      })
    })
}

export const makeRefunds = data => dispatch => {
  dispatch({
    type: MAKE_REFUNDS
  });
  client
    .post('/refunds/processmulti', data)
    .then(({ data: postData }) => {
      dispatch({
        type: MAKE_REFUNDS_SUCCESS,
        reqData: data,
        data: postData
      })
    })
    .catch(error => {
      dispatch({
        type: MAKE_REFUNDS_FAIL,
        data,
        error
      })
    })
}

export const switchMethod = id => dispatch => {
  dispatch({
    type: SWITCH_REFUND_METHOD
  });
  client
    .put(`/refunds/${id}/switch-method`)
    .then(({ data }) => {
      dispatch({
        type: SWITCH_REFUND_METHOD_SUCCESS,
        data
      })
    })
    .catch(error => {
      dispatch({
        type: SWITCH_REFUND_METHOD_FAIL,
        error
      })
    })
}



// WEBPACK FOOTER //
// ./src/redux/actions/refunds.js